import { render, staticRenderFns } from "./DuaMessageRouteField.vue?vue&type=template&id=fd657d2e"
import script from "./DuaMessageRouteField.vue?vue&type=script&lang=js"
export * from "./DuaMessageRouteField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports